import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import { useOrders } from '../context/OrderContext';
import { useNavigate } from 'react-router-dom';
import './CheckoutPage.css';

const CheckoutPage = () => {
  const { items, getCartTotal, clearCart } = useCart();
  const { addOrder } = useOrders();
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    postalCode: '',
    paymentMethod: 'cash'
  });

  const [isProcessing, setIsProcessing] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsProcessing(true);

    // Create order data
    const orderData = {
      customerName: `${formData.firstName} ${formData.lastName}`,
      email: formData.email,
      phone: formData.phone,
      address: formData.address,
      city: formData.city,
      postalCode: formData.postalCode,
      paymentMethod: formData.paymentMethod,
      items: items,
      total: getCartTotal(),
      itemsCount: items.length
    };

    // Simulate payment processing
    setTimeout(() => {
      // Add order to system
      addOrder(orderData);
      clearCart();
      setIsProcessing(false);
      navigate('/order-success');
    }, 2000);
  };

  if (items.length === 0) {
    return (
      <div className="checkout-page">
        <div className="container">
          <h1>إتمام الشراء</h1>
          <div className="empty-checkout">
            <h2>لا توجد عناصر في سلة التسوق</h2>
            <p>يرجى إضافة بعض الكتب إلى سلة التسوق أولاً</p>
            <button onClick={() => navigate('/books')} className="btn btn-primary">
              تصفح الكتب
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="checkout-page">
      <div className="container">
        <h1>إتمام الشراء</h1>
        
        <div className="checkout-content">
          <div className="checkout-form">
            <h2>معلومات الشحن</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>الاسم الأول *</label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>الاسم الأخير *</label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label>البريد الإلكتروني *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>رقم الهاتف *</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>العنوان *</label>
                <textarea
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  rows="3"
                  required
                ></textarea>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>المدينة *</label>
                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>الرمز البريدي</label>
                  <input
                    type="text"
                    name="postalCode"
                    value={formData.postalCode}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="payment-section">
                <h3>طريقة الدفع</h3>
                <div className="payment-options">
                  <label className="payment-option">
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="cash"
                      checked={formData.paymentMethod === 'cash'}
                      onChange={handleInputChange}
                    />
                    <span>الدفع عند الاستلام</span>
                  </label>
                  <label className="payment-option">
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="fawry"
                      checked={formData.paymentMethod === 'fawry'}
                      onChange={handleInputChange}
                    />
                    <span>فوري باي</span>
                  </label>
                  <label className="payment-option">
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="vodafone"
                      checked={formData.paymentMethod === 'vodafone'}
                      onChange={handleInputChange}
                    />
                    <span>فودافون كاش</span>
                  </label>
                </div>
              </div>

              <button 
                type="submit" 
                className="btn btn-primary submit-btn"
                disabled={isProcessing}
              >
                {isProcessing ? 'جاري المعالجة...' : 'تأكيد الطلب'}
              </button>
            </form>
          </div>

          <div className="order-summary">
            <h3>ملخص الطلب</h3>
            <div className="order-items">
              {items.map(item => (
                <div key={item.id} className="order-item">
                  <img src={item.image} alt={item.title} />
                  <div className="item-info">
                    <h4>{item.title}</h4>
                    <p>{item.quantity} × {item.price} جنيه</p>
                  </div>
                  <div className="item-total">
                    {(item.price * item.quantity).toFixed(2)} جنيه
                  </div>
                </div>
              ))}
            </div>
            
            <div className="order-totals">
              <div className="total-row">
                <span>المجموع الفرعي:</span>
                <span>{getCartTotal().toFixed(2)} جنيه</span>
              </div>
              <div className="total-row">
                <span>الشحن:</span>
                <span>مجاني</span>
              </div>
              <div className="total-row final-total">
                <span>المجموع الكلي:</span>
                <span>{getCartTotal().toFixed(2)} جنيه</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPage;
